import { render, staticRenderFns } from "./ProfessionalActivityTaxonomyNew.vue?vue&type=template&id=d74f62f0&"
import script from "./ProfessionalActivityTaxonomyNew.vue?vue&type=script&lang=ts&"
export * from "./ProfessionalActivityTaxonomyNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports